<template>
  <div>
    <div class="google-map-container">
      <div id="googleMarkedMap"></div>
    </div>
    <div class="google-maps-space-helper">.</div>
  </div>
</template>

<script>
export default {
  /* eslint-disable */
  methods: {
    initMap () {
      let budapestCenter = { lat: 47.4813602, lng: 18.9902177 }
      let googleMarkedMap = document.getElementById('googleMarkedMap')
      let clients = this.$store.state.clients
      let markers = []
      let googleMapStyle = [
        {
          'featureType': 'administrative.province',
          'elementType': 'labels.text.fill',
          'stylers': [
            {
              'color': '#ff0000',
            },
            {
              'visibility': 'off',
            },
          ],
        },
        {
          'featureType': 'administrative.locality',
          'elementType': 'all',
          'stylers': [
            {
              'saturation': 7,
            },
            {
              'lightness': '31',
            },
            {
              'visibility': 'on',
            },
            {
              'color': '#f06c01',
            },
          ],
        },
        {
          'featureType': 'administrative.locality',
          'elementType': 'labels.text.stroke',
          'stylers': [
            {
              'visibility': 'off',
            },
          ],
        },
        {
          'featureType': 'landscape',
          'elementType': 'all',
          'stylers': [
            {
              'hue': '#ffffff',
            },
            {
              'saturation': -100,
            },
            {
              'lightness': 100,
            },
            {
              'visibility': 'simplified',
            },
          ],
        },
        {
          'featureType': 'poi',
          'elementType': 'all',
          'stylers': [
            {
              'hue': '#ffffff',
            },
            {
              'saturation': -100,
            },
            {
              'lightness': 100,
            },
            {
              'visibility': 'off',
            },
          ],
        },
        {
          'featureType': 'road',
          'elementType': 'geometry',
          'stylers': [
            {
              'hue': '#bbc0c4',
            },
            {
              'saturation': -93,
            },
            {
              'lightness': 31,
            },
            {
              'visibility': 'simplified',
            },
          ],
        },
        {
          'featureType': 'road',
          'elementType': 'labels',
          'stylers': [
            {
              'hue': '#bbc0c4',
            },
            {
              'saturation': -93,
            },
            {
              'lightness': 31,
            },
            {
              'visibility': 'on',
            },
          ],
        },
        {
          'featureType': 'road.arterial',
          'elementType': 'labels',
          'stylers': [
            {
              'hue': '#bbc0c4',
            },
            {
              'saturation': -93,
            },
            {
              'lightness': -2,
            },
            {
              'visibility': 'simplified',
            },
          ],
        },
        {
          'featureType': 'road.local',
          'elementType': 'geometry',
          'stylers': [
            {
              'hue': '#e9ebed',
            },
            {
              'saturation': -90,
            },
            {
              'lightness': -8,
            },
            {
              'visibility': 'simplified',
            },
          ],
        },
        {
          'featureType': 'transit',
          'elementType': 'all',
          'stylers': [
            {
              'hue': '#e9ebed',
            },
            {
              'saturation': 10,
            },
            {
              'lightness': 69,
            },
            {
              'visibility': 'on',
            },
          ],
        },
        {
          'featureType': 'water',
          'elementType': 'all',
          'stylers': [
            {
              'hue': '#e9ebed',
            },
            {
              'saturation': -78,
            },
            {
              'lightness': 67,
            },
            {
              'visibility': 'simplified',
            },
          ],
        },
      ]

      let map = new google.maps.Map(googleMarkedMap, {
        zoom: 10,
        center: budapestCenter,
        styles: googleMapStyle,
      })

      for (let client of clients) {
        markers.push(
          new google.maps.Marker({
            position: { lat: client.lat, lng: client.lng },
            map: map,
            title: client.name,
          }),
        )
      }
    },
  },
  mounted: function () {
    this.initMap()
  },
}
</script>

<style scoped>

.google-map-container {
  height: 20rem;
  width: 100%;
  position: absolute;
  left: 0;
}

.google-maps-space-helper {
  content: 'kasjdkl';
  height: 25rem;
}

#googleMarkedMap {
  height: 100%;
}
</style>
